import React from 'react'

const Manual_admin_tipos_pago = () => {
  return (
    <div className="px-4 py-16 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 lg:py-10">
      <div className="mt-16">
        <h2 className="font-bold xl-text-[40px] lg:text-4xl md:text-4xl text-4xl text-[#002D33] mb-5">
          Admin - Tipos de Pago
        </h2>
        <p className="text-lg text-gray-700 mb-6">
          La guía explica cómo crear y configurar nuevos tipos de pago en el sistema, permitiendo a los usuarios adaptar opciones de pago según sus necesidades y mejorar su flexibilidad operativa.
        </p>
        <iframe
          src="https://scribehow.com/embed/Admin__Tipos_de_Pago__ZC7xA8_9Tw2kXKVW_WjuAQ?as=scrollable"
          className="scribe-iframe-general-49"
          width="100%"
          height="5700"
          allowFullScreen
          style={{ border: 0, minHeight: '640px' }}
        ></iframe>
      </div>
    </div>
  )
}

export default Manual_admin_tipos_pago